/* eslint-disable import/prefer-default-export */
import { useShopConfigV2 } from '../../../hooks/shopConfig';
import { useListingFlowConfig } from '../../../hooks/useListingFlowConfig';
import { Tier } from '../../../types/shopConfig/shopConfigV2';
import { BackgroundRemovalType } from '../../../types/uploadcare/backgroundRemovalTypes';

export const useIsBackgroundRemovalType = () => {
  const { bgRemovalType } = useListingFlowConfig();
  const { tier } = useShopConfigV2();

  const isPremium = tier === Tier.Premium;
  const isDefault = bgRemovalType === BackgroundRemovalType.Default;
  if (isDefault && isPremium) {
    // Set default for premium brands as CoverRequiredOthersOptional
    return { bgRemovalType: BackgroundRemovalType.CoverRequiredOthersOptional };
  }

  return { bgRemovalType };
};
